import { motion } from "framer-motion";
import { Kicker } from "./Reveal";

const line = {
  hidden: { y: "115%" },
  show: (i) => ({ y: "0%", transition: { duration: 1, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] } }),
};

export const PageHero = ({ kicker, title, lede, children }) => (
  <section className="relative overflow-hidden bg-cream grain pt-40 pb-20 sm:pb-28 px-6">
    <div className="absolute -top-24 -right-24 w-[28rem] h-[28rem] bg-blush/50 organic-blob blur-2xl" />
    <div className="absolute top-40 -left-32 w-[24rem] h-[24rem] bg-ochre/25 organic-blob-alt blur-2xl" />
    <div className="relative max-w-6xl mx-auto">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="text-xs sm:text-sm uppercase tracking-[0.25em] font-bold mb-6 text-terracotta"
      >
        {kicker}
      </motion.p>
      <h1 className="font-display font-light tracking-tight text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-4xl">
        {title.split("\n").map((l, i) => (
          <span key={i} className="block overflow-hidden pb-1">
            <motion.span custom={i} variants={line} initial="hidden" animate="show" className="block">
              {l}
            </motion.span>
          </span>
        ))}
      </h1>
      {lede && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.5 }}
          className="mt-8 text-base lg:text-lg leading-relaxed text-earth max-w-2xl"
        >
          {lede}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
